import * as React from 'react';
import { useSelected } from 'slate-react';
import styled from 'styled-components';

import { BaseBulletPointPluginProps } from '../BulletPointPlugin.types';
import { ListSwitcherPopOver } from '../components/ListSwitcherPopOver';
import { SharedListStyle, SharedCustomBulletPointStyle } from './ListStyle';
import { useCheckListIsFirstChild } from './UnorderedListElement';

const Main = styled.ul`
  ${SharedListStyle}
  ${SharedCustomBulletPointStyle}
  li {
    list-style-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.3151 0.610979C14.6969 0.21009 13.8716 0.38609 13.4711 1.00387L6.00001 12.5199L2.35645 9.15098C1.81556 8.65098 0.97245 8.68387 0.47245 9.22476C-0.0275503 9.7652 0.00533864 10.6092 0.546228 11.1088L5.33023 15.5319C5.33023 15.5319 5.46756 15.6501 5.53112 15.6914C5.75512 15.8372 6.00667 15.9065 6.25556 15.9065C6.69201 15.9065 7.12 15.6923 7.37556 15.2985L15.708 2.45498C16.1089 1.8372 15.9329 1.01142 15.3151 0.610979Z' fill='%23358756'/%3E%3C/svg%3E%0A");
    > div {
      position: relative;
      top: 1px;
    }
  }
  li::marker {
    font-size: 1.5rem;
    line-height: 0;
  }
`;

interface UnorderedListCheckElementProps extends BaseBulletPointPluginProps {}

export const UnorderedListCheckElementEditable = (props: UnorderedListCheckElementProps) => {
  const { children, attributes, isReadOnly } = props;
  const ref = React.useRef();
  const isFirstChild = useCheckListIsFirstChild(ref);
  const selected = useSelected();

  return (
    <Main {...attributes} className="unordered-list-check-element">
      <div ref={ref} />
      {children}
      {!isReadOnly && isFirstChild && selected && <ListSwitcherPopOver />}
    </Main>
  );
};

export const UnorderedListCheckElementReadOnly = (props: UnorderedListCheckElementProps) => {
  const { children, attributes } = props;

  return (
    <Main {...attributes} className="unordered-list-check-element">
      {children}
    </Main>
  );
};
